"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsDialogLazy = void 0;
var _TermsAndConditionsDialog = require("./TermsAndConditionsDialog");
var _TermsAndConditionsDialogProviders = require("./TermsAndConditionsDialogProviders");
var _jsxRuntime = require("react/jsx-runtime");
const TermsAndConditionsDialogLazy = ({
  termId
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_TermsAndConditionsDialogProviders.TermsAndConditionsDialogProviders, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TermsAndConditionsDialog.TermsAndConditionsDialog, {
    termId: termId
  })
});
exports.TermsAndConditionsDialogLazy = TermsAndConditionsDialogLazy;
